import { Checkbox as CheckboxProps } from "./index.types";
import "./index.css";
import clsx from "clsx";
import { getErrorMessage } from "../../utils/get-error-message";

export function Checkbox({
  backgroundColor,
  classNameCheckbox = "",
  classNameGroup = "",
  classNameLabel,
  error = {
    is: false,
    message: "",
  },
  // icon,
  inputRef,
  isRequired,
  label,
  placeholder = "Insert value",
  styleGroup,
  ...rest
}: CheckboxProps) {
  return (
    <div
      className={clsx("input-group", classNameGroup)}
      style={{ backgroundColor: backgroundColor, ...styleGroup }}
    >
      <div className="checkbox__header">
        {label && <label className={classNameLabel}>{label}</label>}
        {error && error.is && getErrorMessage(error.message) && (
          <span className="input__header--error">
            {getErrorMessage(error.message)}
          </span>
        )}
      </div>
      <div className="checkbox-subgroup">
        <input
          ref={inputRef}
          type="checkbox"
          required={isRequired}
          className={clsx(
            "checkbox",
            error.is ? "checkbox--error" : "",
            classNameCheckbox
          )}
          placeholder={placeholder}
          {...rest}
        />
      </div>
    </div>
  );
}

export default Checkbox;
